import { Helmet } from "react-helmet-async";
import { SITE_URL } from "./Seo";
import { CONTACT, SOCIAL } from "../mock";

const StructuredData = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": ["Organization", "Store"],
    "@id": `${SITE_URL}/#organization`,
    name: "Koşan Düğme İmalat San. ve Tic. Ltd. Şti.",
    alternateName: "Koşan Düğme",
    url: SITE_URL,
    logo: `${SITE_URL}/images/products/logo_horizontal.png`,
    image: `${SITE_URL}/images/og-cover.jpg`,
    description:
      "1993'ten beri metal tekstil aksesuarları üreticisi. Çıtçıt, kuşgözü, perçin, kot düğme, toka, stoper ve bağ ucu. İhracata uygun kalite standartlarında yerli üretim.",
    telephone: CONTACT.phone,
    email: CONTACT.emails[0],
    foundingDate: "1993",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Sanayi Mah. Gürbüz Sok. No: 44",
      addressLocality: "Güngören",
      addressRegion: "İstanbul",
      postalCode: "34173",
      addressCountry: "TR",
    },
    areaServed: "TR",
    sameAs: [SOCIAL.instagram, SOCIAL.linkedin],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: CONTACT.rating,
      reviewCount: CONTACT.reviews,
      bestRating: "5",
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:30",
        closes: "18:30",
      },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "08:30", closes: "14:00" },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default StructuredData;
